import React from 'react';
import { I18n as I } from 'react-redux-i18n';
import { history } from 'data/Store';
import QuickBidModal from 'components/bids/QuickBidModal';
import AuctionsListFilters, {
  BidTypesFilterName,
  NoBidFilterValue,
} from './AuctionsListFilters';
import ImageGallery from 'components/common/ImageGallery';
import { filterData } from './AuctionsListFilters/utils';
import { formatBidTypes } from './utils';

import moment from 'moment';

import { Spin, Table, Button, Row, Col } from 'antd';
import {
  ConfirmationModal,
  formatCurrency,
  isArray,
  PartTypes,
  PartyTypes,
  AuctionStatuses,
} from 'vdlib';
import { getColumns, getPartColumns } from './columns';

import _ from 'lodash';

import Portlet from 'components/layout/Portlet';
import LookupsHelper from 'lib/LookupsHelper';
import { usePartyFlagsAndColumnDefsKey } from 'lib/Hooks';

import RoleStatusColumnDefs from './ui-data/AuctionsColumnsDefs';
import RoleStatusPartsColumnsDefs from './ui-data/AuctionsPartsColumnsDefs';

import AuctionDurationModal from './AuctionDurationModal';

import BidSelectorWizardContainer from 'containers/bids/BidSelectorWizardContainer';

import getGridActions, { GridActionTypes } from './ui-data/AuctionGridActions';

const stepTitleOlder = 'Παλιότερες';
const stepTitleNewer = 'Νεότερες';

const imageStyle = {
  height: '36px',
  width: '36px',
  textAlign: 'center',
};

const pagination = { position: 'bottom', size: 'small' };

const bidTypeData = [
  {
    id: PartTypes.New,
    description: 'PART_TYPE_NEW_PL',
    className: 'label-success',
  },
  {
    id: PartTypes.Used,
    description: 'PART_TYPE_USED_PL',
    className: 'label-danger',
  },
  {
    id: PartTypes.Imitation,
    description: 'PART_TYPE_IMITATION',
    className: 'label-warning',
  },
  {
    id: 'NoBid',
    description: 'NO_OFFER',
    className: 'label-info',
  },
];
const formatBidType = ({ description, className }) => (
  <i className={`label ${className}`}>{I.t(description)}</i>
);

const modalTypes = {
  acceptAuction: 'accept-auction',
  auctionComments: 'auction-comments',
  auctionDuration: 'auction-duration',
  cancelAuction: 'cancel-auction',
  dispatchAuction: 'dispatch-auction',
  dispatchProblem: 'dispatch-problem',
  rejectAuction: 'reject-auction',
  endAuctions: 'end-auctions',
};

const partContainsBidType = (part, bidTypesFilterValue) => {
  if (!Array.isArray(part.Bids) || part.Bids.length === 0)
    return bidTypesFilterValue.includes(NoBidFilterValue);

  return part.Bids.some(b => bidTypesFilterValue.includes(b.PartType));
};

const filterMapReducer = (obj, name) => {
  if (name === BidTypesFilterName) obj[name] = partContainsBidType;
  else obj[name] = filterData.find(f => f.name === name)?.type || 'text';
  return obj;
};
const foldersFilterMap = [
  'FolderNumber',
  'InsuranceID',
  'PlateNumber',
  'RegionID',
  'VehicleBrand',
  'VehicleModel',
].reduce(filterMapReducer, {});
const partsFilterMap = [
  BidTypesFilterName,
  'CreatedDate',
  'ID',
  'PartNumber',
  'PartDescription',
].reduce(filterMapReducer, {});

// onSelectionChanged = () => {
//   if (isNil(this.api)) return;

//   var selectedRows = this.api.getSelectedRows();
//   //var selectedRowsString = 0;
//   this._selectedRows = selectedRows;

//   if (!isNil(this._columnDefs.find(c => c.id == 'Αρχ.Τιμή'))) {
//     var partPrice = 0;

//     selectedRows.forEach((selectedRow, index) => {
//       partPrice += selectedRow.PartPrice;
//       this.setState({ partPriceTotal: partPrice });
//     });
//   }

//   this.setState({ selectedRowsTotal: selectedRows.length });

//   let rowsAuctionIDs = isArray(selectedRows)
//     ? selectedRows.map(r => r.ID)
//     : [];

//   this.setState({ selectedRowsAuctionIDs: rowsAuctionIDs });
// };

// partTypesRowFilterFn = (columnDef, checkedItems, params) => {
//   var data = params.data.Bids,
//     checkedIds = Object.keys(checkedItems).filter(
//       key => checkedItems[key] === true
//     );

//   if (checkedIds.length == 0) return false;
//   if (data.length == 0) return checkedIds.indexOf('NoBid') >= 0;

//   var bidPartTypes = data.map(b =>
//     LookupsHelper.getDescription(this.props.partTypes, b.PartTypeID)
//   );
//   return bidPartTypes.find(b => checkedIds.indexOf(b) >= 0) != null;
// };

const stringComparator = (value, filterValue) => {
  if (!value) return false;
  const stringValue = String(value).toLowerCase();
  const compareValue = String(filterValue).toLowerCase();
  return stringValue.indexOf(compareValue) > -1;
};

const PartsList = ({
  auctionStatus,
  columnPartsDefs,
  columnsPartsWidth,
  exportPdfAuctions,
  filters,
  parts,
  partTypes,
  partyTypes,
  selection,
  setModalType,
  setSelection,
  user,
}) => {
  const [partPriceTotal, setPartPriceTotal] = React.useState(0);

  // augment data source with PartType code
  const formattedParts = React.useMemo(
    () =>
      !Array.isArray(parts) || !Array.isArray(partTypes)
        ? []
        : parts.map(part => ({
            ...part,
            Bids: (part.Bids || []).map(b => ({
              ...b,
              PartType: LookupsHelper.getDescription(partTypes, b.PartTypeID),
            })),
          })),
    [parts, partTypes]
  );

  const { selectedRowsTotal, selectedRowKeys, selectedRowsAuctionIDs } =
    selection;

  const { isInsurance, isOperator, partyType } = usePartyFlagsAndColumnDefsKey(
    user,
    partyTypes,
    auctionStatus
  );

  const showChecks = React.useMemo(() => {
    if (isOperator && ['Pending'].includes(auctionStatus)) return true;
    else if (isInsurance && ['ForSelection'].includes(auctionStatus))
      return true;
    else return false;
  }, [isOperator, isInsurance, auctionStatus]);

  const gridActions = React.useMemo(() => {
    const gridActionsCallbacks = {
      [GridActionTypes.StartAuction]: () =>
        setModalType(modalTypes.auctionDuration),
      [GridActionTypes.AcceptAuction]: () => setModalType(modalTypes.auction),
      [GridActionTypes.DispatchAuction]: () =>
        setModalType(modalTypes.dispatchAuction),
      [GridActionTypes.CancelAuction]: () =>
        setModalType(modalTypes.cancelAuction),
      [GridActionTypes.EndAuctions]: () => setModalType(modalTypes.endAuctions),
      [GridActionTypes.PrintAuctions]: () =>
        selection.selectedRowsAuctionIDs
          ? exportPdfAuctions(
              isArray(selection.selectedRowsAuctionIDs)
                ? selection.selectedRowsAuctionIDs
                : [],
              LookupsHelper.getIdByDescription(
                'auctionStatuses',
                auctionStatus
              ),
              formatBidTypes(filters),
              false
            )
          : null,
      [GridActionTypes.PrintSelectedAuctions]: () =>
        selection.selectedRowsAuctionIDs
          ? exportPdfAuctions(
              isArray(selection.selectedRowsAuctionIDs)
                ? selection.selectedRowsAuctionIDs
                : [],
              LookupsHelper.getIdByDescription(
                'auctionStatuses',
                auctionStatus
              ),
              formatBidTypes(filters),
              true
            )
          : null,
    };

    const gridActionsRaw = getGridActions(
      partyType,
      auctionStatus,
      gridActionsCallbacks,
      this
    );

    return Array.isArray(gridActionsRaw)
      ? gridActionsRaw.map((ra, idx) => (
          <button
            type="button"
            className={`btn btn-sm float-left mr-sm ${ra.className || ''}`}
            onClick={ra.onClick}
          >
            {ra.title}
          </button>
        ))
      : false;
  }, [
    setModalType,
    partyType,
    auctionStatus,
    selection,
    exportPdfAuctions,
    filters,
  ]);

  const calculateSelectedTotalPrice = selectedRows => {
    if (selectedRows && selectedRows.length > 0) {
      if (columnPartsDefs.find(x => x.key === 'Αρχ.Τιμή')) {
        var partPrice = 0;

        selectedRows.forEach((selectedRow, index) => {
          partPrice += selectedRow.PartPrice;
          setPartPriceTotal(partPrice);
        });
      } else setPartPriceTotal(0);
    } else setPartPriceTotal(0);
  };

  const onSelectChange = React.useCallback(
    (selectedRowKeys, selectedRows) => {
      setSelection({
        selectedRowKeys: Array.isArray(selectedRows)
          ? selectedRows.map(r => r.ID)
          : [],
        selectedRowsTotal: selectedRows.length,
        selectedRowsAuctionIDs: Array.isArray(selectedRows)
          ? selectedRows.map(r => r.ID)
          : [],
        selectedRowsAuctions: Array.isArray(selectedRows) ? selectedRows : [],
      });
      calculateSelectedTotalPrice(selectedRows);
    },
    [setSelection, setPartPriceTotal] //eslint-disable-line
  );

  const rowSelection = React.useMemo(
    () => ({
      fixed: true,
      onChange: onSelectChange,
      renderCell: (checked, record, index, originNode) => (
        <div className="cell-fix-wrap">{originNode}</div>
      ),
      selectedRowKeys,
    }),
    [onSelectChange, selectedRowKeys]
  );

  // actual auction data that will be sent to table
  const filteredParts = React.useMemo(() => {
    if (!formattedParts) return [];

    const applicableFilters = filters.filter(
      f => f.Name && !!partsFilterMap[f.Name]
    );

    const filterFunc =
      Array.isArray(filters) && filters.length > 0
        ? part =>
            applicableFilters.every(f =>
              typeof partsFilterMap[f.Name] === 'function'
                ? partsFilterMap[f.Name](part, f.Value)
                : partsFilterMap[f.Name] === 'dropdown'
                ? part[f.Name] === f.Value
                : stringComparator(part[f.Name], f.Value)
            )
        : item => item;

    return formattedParts.filter(filterFunc);
  }, [formattedParts, filters]);

  return (
    <Table
      rowKey="ID"
      showHeader={true}
      size="small"
      rowSelection={showChecks ? rowSelection : null}
      columns={columnPartsDefs}
      dataSource={filteredParts}
      pagination={false}
      className="parts"
      scroll={{ x: columnsPartsWidth }}
      footer={() =>
        showChecks ? (
          <Row>
            <Col xs={6}>
              <span>
                {I.t('AUCTIONS_CHOSEN')}: <strong>{selectedRowsTotal}</strong>
              </span>
            </Col>
            <Col xs={10}>{selectedRowsTotal ? gridActions : null}</Col>
            <Col xs={8}>
              {partPriceTotal > 0 ? (
                <span className="float-right">
                  {I.t('TOTAL_INITIAL_PRICE')}:{' '}
                  <strong>{formatCurrency(partPriceTotal)}</strong>
                </span>
              ) : (
                <span>&nbsp;</span>
              )}
            </Col>
          </Row>
        ) : null
      }
    />
  );
};

const AuctionsList = ({
  acceptAuction,
  auctions,
  auctionStatus,
  bids,
  cancelling,
  cancelAuction,
  cancelAuctions,
  clearFilters,
  createdBid,
  createBids,
  currentAuctionBids,
  dispatchAuction,
  endAuction,
  endAuctions,
  exportPdfAuctions,
  fetchAuctions,
  fetchBidsForAuction,
  fetchingAuctions,
  fetchingCurrentAuctionBids,
  filters,
  imitationPartCategories,
  insurances,
  lang,
  location,
  partTypes,
  partyTypes,
  regions,
  //rejectAuction,
  setFilter,
  startAuctions,
  submitting,
  usedConditionTypes,
  user,
  vehicleTypes,
}) => {
  const [selection, setSelection] = React.useState({});
  const [currentStep, setCurrentStep] = React.useState(0);
  const [modalType, setModalType] = React.useState(null);
  const [auctionToDispatch, setAuctionToDispatch] = React.useState({});
  const [quickBidData, setQuickBidData] = React.useState({});
  const [auctionToStartId, setAuctionToStartId] = React.useState(null);
  const [auctionToAccept, setAuctionToAccept] = React.useState({});
  const [auctionToCancel, setAuctionToCancel] = React.useState({});
  const [selectedAuction, setSelectedAuction] = React.useState({});
  const [selectedBid, setSelectedBid] = React.useState(null);
  const [selectedBidTypes, setSelectedBidTypes] = React.useState([]);
  const [galleryImages, setGalleryImages] = React.useState(null);

  const [modelsDropdownDataSource, setModelsDropdownDataSource] =
    React.useState([]);
  const [totalPrice, setTotalPrice] = React.useState({ best: 0, part: 0 });
  const [visiblePartTypes, setVisiblePartTypes] = React.useState(
    Object.values(PartTypes)
  );

  const groupedAuctions = React.useMemo(() => {
    const groupedData = _.groupBy(auctions, 'FolderNumber');
    return groupedData
      ? Object.values(groupedData).map(x => ({
          ID: x[0].ID,
          Images: x[0].Images,
          Thumbnails: x[0].Thumbnails,
          InsuranceID: x[0].InsuranceID,
          ExpertUsername: x[0].ExpertUsername,
          FolderNumber: x[0].FolderNumber,
          VehicleBrand: x[0].VehicleBrand,
          VehicleModel: x[0].VehicleModel,
          RegionID: x[0].RegionID,
          PlateNumber: x[0].PlateNumber,
          IsFromFile: x[0].IsFromFile,
          Parts: x,
          EndDate: moment.unix(Math.min(...x.map(m => m.EndDate.unix()))),
        }))
      : [];
  }, [auctions]);

  const {
    isExpert,
    isInsurance,
    isMerchant,
    isOperator,
    partyType,
    columnDefsKey,
  } = usePartyFlagsAndColumnDefsKey(user, partyTypes, auctionStatus);

  /* Required callbacks for column defs */
  const handleOfferClick = React.useCallback(
    auction => {
      const auctionId = auction.ID;
      fetchBidsForAuction(auctionId);
      //let auction = auctions.find(a => a.ID == auctionId);
      setQuickBidData({
        auctionId,
        description: auction.PartDescription,
        partNumber: auction.PartNumber,
      });
      setSelectedAuction(auction);
    },
    //eslint-disable-next-line
    [fetchBidsForAuction, setModalType, setQuickBidData, setSelectedAuction]
  );

  const handleBidClick = React.useCallback(
    (record, bid) => {
      // open bid selection wizard modal
      setSelectedBid({
        ...bid,
        GarageId: record.GarageID,
        PartDescription: LookupsHelper.getDescription(
          partTypes,
          bid.PartTypeID
        ),
      });
    },
    [partTypes]
  );

  const onPhotoClick = React.useCallback(
    ({ FolderNumber, Images, Thumbnails }) =>
      setGalleryImages(
        Images.map((img, i) => ({
          id: img.Filepath,
          original: img.Filepath,
          thumbnail: Thumbnails[i].Filepath,
        }))
      ),
    [setGalleryImages]
  );

  const imageGalleryRef = React.useCallback(elem => {
    if (elem && elem.fullScreen) elem.fullScreen();
  }, []);

  /* Column Definitions */
  const columnDefsDataContext = React.useMemo(
    () => ({
      columnDefsKey,
      insurances,
      regions,
      user,
      // visiblePartTypes,
    }),
    [
      columnDefsKey,
      insurances,
      //onPhotoClick,
      regions,
      user,
      // visiblePartTypes,
    ]
  );

  const columnPartDefsDataContext = React.useMemo(
    () => ({
      columnDefsKey,
      onBidClick:
        auctionStatus === AuctionStatuses.ForSelection
          ? handleBidClick
          : handleOfferClick,
      onOfferClick: handleOfferClick,
      onSetAuctionToAccept: setAuctionToAccept,
      onSetAuctionToCancel: setAuctionToCancel,
      onSetAuctionToDispatch: setAuctionToDispatch,
      onSetAuctionToStartId: setAuctionToStartId,
      setAuctionToAccept,
      visiblePartTypes,
      user,
    }),
    [
      auctionStatus,
      columnDefsKey,
      handleBidClick,
      handleOfferClick,
      setAuctionToAccept,
      setAuctionToCancel,
      setAuctionToDispatch,
      setAuctionToStartId,
      visiblePartTypes,
      user,
    ]
  );

  const { columnDefs } = React.useMemo(() => {
    if (!insurances || !partyType) return {};
    const allColumnDefs = getColumns(columnDefsDataContext);

    let columnsSet = RoleStatusColumnDefs[columnDefsKey];

    if (!columnsSet)
      console.error(
        `AuctionsList: Could not find suitable columns set for type: ${partyType}, status: ${auctionStatus}`
      );

    return {
      columnDefs: columnsSet
        ? columnsSet.map(elem => allColumnDefs.find(cd => cd.key === elem))
        : null,
    };
    // eslint-disable-next-line
  }, [
    auctionStatus,
    columnDefsDataContext,
    insurances,
    lang,
    //lost,
    //noOffer,
    //participate,
    partyType,
  ]);

  const { columnPartsDefs, showBidsCheckboxes } = React.useMemo(() => {
    if (!insurances || !partyType) return {};
    const allColumnDefs = getPartColumns(columnPartDefsDataContext);

    let columnsSet = RoleStatusPartsColumnsDefs[columnDefsKey];

    return {
      columnPartsDefs: columnsSet
        ? columnsSet.map(elem => allColumnDefs.find(cd => cd.key === elem))
        : console.error(
            `PartsList: Could not find suitable columns set for type: ${partyType}, status: ${auctionStatus}`
          ),
      showBidsCheckboxes:
        columnsSet.includes('Προσφορές') ||
        columnsSet.includes('Clickable Προσφορές'),
    };
    // eslint-disable-next-line
  }, [
    auctionStatus,
    columnPartDefsDataContext,
    insurances,
    lang,
    //lost,
    //noOffer,
    //participate,
    partyType,
  ]);

  const bidTypes = React.useMemo(() => bidTypeData.map(formatBidType), [lang]); //eslint-disable-line

  // what the user *can* do
  const can = React.useMemo(() => {
    const obj = {
      acceptAuction:
        partyType === PartyTypes.Merchant &&
        auctionStatus === AuctionStatuses.ForAcceptance,
      cancel:
        auctions != null &&
        partyType === PartyTypes.Insurance &&
        auctionStatus === AuctionStatuses.ForSelection &&
        !!auctions.find(a => !isArray(a.Bids) || a.Bids.length === 0),
      cancelAuction:
        (partyType === PartyTypes.Insurance ||
          partyType === PartyTypes.Admin_Insurance ||
          partyType === PartyTypes.Operator) &&
        [
          AuctionStatuses.Active,
          AuctionStatuses.ForSelection,
          AuctionStatuses.Pending,
        ].includes(auctionStatus),
      endAuction:
        partyType === PartyTypes.Insurance &&
        [AuctionStatuses.Active, AuctionStatuses.ForSelection].includes(
          auctionStatus
        ),
      makeBid:
        partyType === PartyTypes.Merchant &&
        auctionStatus === AuctionStatuses.Active,
      startAuction:
        (partyType === PartyTypes.Admin_Insurance ||
          partyType === PartyTypes.Operator) &&
        auctionStatus === AuctionStatuses.Pending,
    };
    obj.cancelBid = obj.makeBid && Array.isArray(bids) && bids.length > 0;
    return obj;
  }, [auctions, bids, partyType, auctionStatus]);

  // brands to be used in dropdown
  const { brands } = React.useMemo(() => {
    const brandModels = {};

    if (auctions != null) {
      for (let d of auctions) {
        if (!isArray(brandModels[d.VehicleBrand]))
          brandModels[d.VehicleBrand] = [];
        if (brandModels[d.VehicleBrand].indexOf(d.VehicleModel) < 0)
          brandModels[d.VehicleBrand].push(d.VehicleModel);
      }
    }

    return {
      brands: Object.keys(brandModels)
        .sort()
        .map((b, i) => ({ ID: i + 1, Description: b })),
      brandModels,
    };
  }, [auctions]);

  const isLast = React.useMemo(
    () => auctions && auctions.length < 100,
    [auctions]
  );

  // actual folder data that will be sent to table
  const filteredFolders = React.useMemo(() => {
    if (!groupedAuctions || !filters) return [];

    const applicableFilters = filters.filter(
      f => f.Name && !!foldersFilterMap[f.Name]
    );

    const filterFunc =
      Array.isArray(filters) && filters.length > 0
        ? folder =>
            applicableFilters.every(f =>
              foldersFilterMap[f.Name] === 'dropdown'
                ? folder[f.Name] === f.Value
                : stringComparator(folder[f.Name], f.Value)
            )
        : item => item;

    return groupedAuctions.filter(filterFunc);
  }, [groupedAuctions, filters]);

  const columnsWidth = React.useMemo(
    () =>
      (columnDefs || []).reduce(
        (sum, { width } = {}) => sum + (typeof width === 'number' ? width : 0),
        400
      ),
    [columnDefs]
  );

  const columnsPartsWidth = React.useMemo(
    () =>
      (columnPartsDefs || []).reduce(
        (sum, { width }) => sum + (typeof width === 'number' ? width : 0),
        400
      ),
    [columnPartsDefs]
  );

  /* Callbacks */

  const loadOlder = React.useCallback(
    () => setCurrentStep(currStep => currStep + 1),
    [setCurrentStep]
  );
  const loadNewer = React.useCallback(
    () => setCurrentStep(currStep => currStep - 1),
    [setCurrentStep]
  );

  const hideModals = React.useCallback(() => {
    setAuctionToAccept({});
    setAuctionToCancel({});
    setAuctionToDispatch({});
    setAuctionToStartId(null);
    setQuickBidData({});

    setModalType(null);
  }, [
    setAuctionToAccept,
    setAuctionToCancel,
    setAuctionToDispatch,
    setAuctionToStartId,
    setModalType,
    setQuickBidData,
  ]);

  const submitEndAuctions = React.useCallback(() => {
    endAuctions(selection.selectedRowsAuctionIDs, formatBidTypes(filters));
    hideModals();
  }, [endAuctions, selection, filters, hideModals]);

  const submitStartAuctions = React.useCallback(
    endDate => startAuctions(selection.selectedRowsAuctions),
    [selection, startAuctions]
  );

  const submitCancelAuctions = React.useCallback(
    () => cancelAuctions(selection.selectedRowsAuctionIDs),
    [selection, cancelAuctions]
  );

  const handleQuickBidSubmit = React.useCallback(
    ({ bids, comments, usedConditionTypeID, imitationCategoryID }) => {
      if (!Array.isArray(bids) || bids.length === 0) return hideModals();

      createBids(
        quickBidData.auctionId,
        bids.map(b => ({
          Amount: b.amount,
          Comments: comments,
          PartTypeID: LookupsHelper.getIdByDescription(partTypes, b.partType),
          ImitationCategoryID:
            b.partType === 'Imitation' ? imitationCategoryID : null,
          UsedConditionTypeID:
            b.partType === 'Used' ? usedConditionTypeID : null,
        }))
      );
    },
    [createBids, hideModals, quickBidData, partTypes]
  );

  // conditions under which to hide modals
  React.useEffect(() => {
    if (submitting || cancelling) hideModals();
  }, [hideModals, cancelling, submitting]);

  React.useEffect(() => {
    if (createdBid) history.push({ pathname: '/' });
  }, [createdBid]);

  React.useEffect(() => {
    if (filters && filters.forLocation !== location.pathname) clearFilters();

    setFilter('forLocation', location.pathname);
    fetchAuctions(currentStep);
  }, [fetchAuctions, currentStep]); //eslint-disable-line

  const { selectedRowsTotal, selectedRowKeys } = selection;

  return (
    <div>
      <h1 className="page-title">{I.t('AUCTIONS')}</h1>
      <AuctionsListFilters
        auctionStatuses={AuctionStatuses}
        brands={brands}
        columnDefsKey={columnDefsKey}
        filters={filters}
        insurances={insurances}
        isExpert={isExpert}
        isInsurance={isInsurance}
        isOperator={isOperator}
        lang={lang}
        location={location}
        regions={regions}
        setFilter={setFilter}
        showBidsCheckboxes={showBidsCheckboxes}
        vehicleTypes={vehicleTypes}
      />
      <Portlet className="pt0" bodyClassName="form-horizontal">
        <div className="row">
          <div className="col-12">
            {isLast ? null : (
              <Button className="pull-right" type="link" onClick={loadOlder}>
                {stepTitleOlder}
              </Button>
            )}
            {currentStep > 0 ? (
              <Button className="pull-right" type="link" onClick={loadNewer}>
                {stepTitleNewer}
              </Button>
            ) : null}
          </div>
        </div>
        <hr className="clear clearfix mt-sm mb-sm" />
        {/* <div className="clearfix mb-sm">{this.gridActions}</div> */}

        <div>
          <Spin spinning={fetchingAuctions} size="large" tip="Loading...">
            <Table
              pagination={pagination}
              rowKey="ID"
              // rowSelection={isOperator ? rowSelection : null}
              columns={columnDefs}
              dataSource={filteredFolders}
              expandable={{
                expandedRowRender: record => (
                  <PartsList
                    auctionStatus={auctionStatus}
                    columnPartsDefs={columnPartsDefs}
                    columnsPartsWidth={columnsPartsWidth}
                    exportPdfAuctions={exportPdfAuctions}
                    filters={filters}
                    parts={record.Parts}
                    partTypes={partTypes}
                    partyTypes={partyTypes}
                    selection={selection}
                    setModalType={setModalType}
                    setSelection={setSelection}
                    user={user}
                  />
                ),
              }}
              rowClassName={() => 'table-row-height'}
              scroll={{ x: columnsWidth }}
            />
          </Spin>
        </div>
      </Portlet>
      {isMerchant && (
        <QuickBidModal
          auctionId={quickBidData?.auctionId}
          show={!!quickBidData?.auctionId}
          loading={fetchingCurrentAuctionBids || submitting}
          bids={currentAuctionBids}
          onHide={hideModals}
          onSubmit={handleQuickBidSubmit}
          originPartType={quickBidData.originPartType}
          description={quickBidData.description}
          partNumber={quickBidData.partNumber}
          imitationCategories={imitationPartCategories}
          usedConditionTypes={usedConditionTypes}
        />
      )}

      {can.cancel && (
        <ConfirmationModal
          onHide={() => setAuctionToCancel({})}
          loading={submitting}
          show={Object.keys(auctionToCancel).length > 0}
          title={I.t('AUCTION_CANCEL')}
          onSubmit={() => cancelAuction(auctionToCancel.ID)}
          rejectButton={false}
          promptText={
            <div className="note note-danger">
              {I.t('AUCTION_CANCEL_FOR')}
              <span className="bold">
                {auctionToCancel.PartDescription} ({auctionToCancel.PartNumber})
              </span>{' '}
              {I.t('WITH_INITIAL_PRICE')}{' '}
              <span className="bold danger">
                {formatCurrency(auctionToCancel.PartPrice)}
              </span>
              <br />
              <br />
              {I.t('ARE_YOU_SURE')}
            </div>
          }
        />
      )}
      {can.cancelAuction ? (
        <ConfirmationModal
          onHide={() => setModalType(null)}
          loading={cancelling}
          show={modalType === 'cancel-auction'}
          title={I.t('AUCTION_CANCEL_ALL')}
          onSubmit={submitCancelAuctions}
          rejectButton={false}
          promptText={
            <div className="note note-danger">
              {I.t('AUCTION_CANCEL_ALL_ASK')}
              <br />
              <br />
              {I.t('ARE_YOU_SURE')}
            </div>
          }
        />
      ) : (
        false
      )}
      {can.endAuction ? (
        <ConfirmationModal
          onHide={() => setModalType(null)}
          loading={submitting}
          show={modalType === 'end-auctions'}
          title={I.t('AUCTION_SELECT_LOWEST_PRICES_ALL')}
          onSubmit={submitEndAuctions}
          rejectButton={false}
          promptText={
            <div className="note note-danger">
              {I.t('AUCTION_SELECT_LOWEST_PRICES_ALL_ASK')}
              <br />
              <br />
              {I.t('ARE_YOU_SURE')}
            </div>
          }
        />
      ) : (
        false
      )}
      {can.startAuction ? (
        <AuctionDurationModal
          show={auctionToStartId != null || modalType === 'auction-duration'}
          submitButton={I.t('APPROVAL')}
          loading={submitting}
          onHide={() => setAuctionToStartId(null)}
          onSubmit={(endDate, comments) =>
            startAuctions(
              auctions
                .filter(
                  x =>
                    selection?.selectedRowsAuctionIDs?.includes(x.ID) ||
                    x.ID === auctionToStartId
                )
                .map(x => {
                  return {
                    ...x,
                    EndDate: endDate,
                  };
                }),
              comments
            )
          }
        />
      ) : (
        false
      )}
      {auctionStatus === AuctionStatuses.ForAcceptance && isMerchant && (
        <ConfirmationModal
          onHide={() => setAuctionToAccept({})}
          loading={submitting}
          show={Object.keys(auctionToAccept).length > 0}
          title={I.t('OFFER_APPROVE')}
          onSubmit={() => acceptAuction(auctionToAccept.ID)}
          withComments={true}
          rejectButton={false}
          //onReject={ (comments) => rejectAuction(auctionToAccept.ID, comments) }
          promptText={I.t('OFFER_APPROVE_ASK')}
        />
      )}

      {(auctionStatus === AuctionStatuses.ForDispatch ||
        auctionStatus === AuctionStatuses.DispatchProblem) &&
        isMerchant && (
          <ConfirmationModal
            onHide={() => setAuctionToDispatch({})}
            loading={submitting}
            show={Object.keys(auctionToDispatch).length > 0}
            title={I.t('PART_SEND')}
            onSubmit={() => dispatchAuction(auctionToDispatch.ID)}
            withComments={true}
            rejectButton={false}
            //onReject={ (comments) => dispatchAuction(auctionToDispatch.ID, true, comments) }
            promptText={I.t('PART_SEND_FINISHED_ASK')}
          />
        )}

      {auctionStatus === AuctionStatuses.ForSelection && isInsurance && (
        <BidSelectorWizardContainer
          show={!!selectedBid}
          garageId={(selectedBid || {}).GarageId}
          partDescription={(selectedBid || {}).PartDescription}
          onSubmit={endAuction}
          loading={submitting}
          bid={selectedBid}
          onHide={() => setSelectedBid(null)}
        />
      )}

      {galleryImages && (
        <ImageGallery
          imageGalleryRef={imageGalleryRef}
          items={galleryImages}
          onScreenChange={fullScreenElem =>
            !fullScreenElem && setGalleryImages(null)
          }
        />
      )}
    </div>
  );
};

export default AuctionsList;
